import React from 'react'
import withOnlyOnDIFM from '../OnlyWithOnDIFM/OnlyOnDifm'
import useIsDifmPersistenceEnabled from '../store/hooks/useIsDifmPersistenceEnabled'
import InstallAtShopCart, { IInstallAtShopCartProps } from './InstallAtShopCart'
import InstallAtShopPersistCart from './InstallAtShopPersistCart'

const InstallAtShopWrapperCart: React.FC<IInstallAtShopCartProps> = ({
  addVehicleTrigger,
  cartItemData,
  lastSkuEta,
}) => {
  const isPersistenceEnabled = useIsDifmPersistenceEnabled()

  return isPersistenceEnabled
    ? <InstallAtShopPersistCart />
    : (
      <InstallAtShopCart
        addVehicleTrigger={addVehicleTrigger}
        cartItemData={cartItemData}
        lastSkuEta={lastSkuEta}
      />
    )
}

export default withOnlyOnDIFM(InstallAtShopWrapperCart)
